import React, { PureComponent, Fragment } from 'react';
import { Row, Card, CardBody } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import classnames from 'classnames';
import Pluralize from 'react-pluralize';
import moment from 'moment';
import { Colxx, Separator } from 'Components/CustomBootstrap';
import BreadcrumbContainer from 'Components/BreadcrumbContainer';
import DataTablePagination from 'Components/DataTables/pagination';
import {
	userRolesFindAllByPageAndOptions,
	errorReset,
} from 'Redux/actions';
import * as userRolesReducer from 'Redux/userRoles/reducer';
import IntlMessages from 'Util/IntlMessages';

class PageUserRoles extends PureComponent {
	constructor() {
		super();
		this.state = {
			keyword: '',
			tableState: {},
		};
		this.breadcrumb = [
			{ id: 'menu.user', href: '/user' },
			{ id: 'menu.user.manage-role', href: '/user/role/list' },
		];
		this.columns = [
			{
				id: 'name',
				Header: 'Role',
				accessor: (d) => (
					<NavLink
						to={ `/app/user-role/edit/${d.id}` }
						className="list-item-heading mb-1 truncate w-20 w-xs-100"
					>
						{ d.name }
					</NavLink>
				),
			},
			{
				id: 'users',
				Header: 'Users',
				sortable: false,
				accessor: (d) => (
					d.users === null ? (
						'N/A'
					) : (
						<p className="text-muted">
							<Pluralize singular="User" count={ d.users.length } />
						</p>
					)
				),
			},
			{
				id: 'updated_on',
				Header: 'Last Modified',
				accessor: (d) => (
					<p className="text-muted">
						{ d.updated_on ? moment(d.updated_on).format('YYYY-MM-DD HH:mm:ss') : '' }
					</p>
				)
			},
			{
				id: 'status',
				Header: 'Status',
				width: 100,
				accessor: (d) => {
					if (!d.status) {
						return null;
					}
					let className = 'badge-primary';
					switch (d.status.label) {
					case 'Inactive':
						className = 'badge-light';
						break;
					}
					return (
						<span className={ classnames('badge', 'badge-pill', 'text-uppercase', className) }>{ d.status.label }</span>
					);
				},
			},
			{
				id: 'action',
				Header: '',
				width: 50,
				accessor: (d) => (
					<NavLink className="btn btn-xs btn-outline-primary" to={ `/app/user-role/edit/${d.id}` }>
						<i className="simple-icon-pencil" />
					</NavLink>
				)
			},
		];
		this.fetchData = this.fetchData.bind(this);
		this.onChangeKeywordHandler = this.onChangeKeywordHandler.bind(this);
		this.onSubmitHandler = this.onSubmitHandler.bind(this);
	}

	componentDidMount() {
		this.props.errorReset('userRoles');
	}

	fetchData(state) {
		const { keyword } = this.state;
		let params = {
			page: state.page + 1,
			size: state.pageSize,
		};
		if (state.sorted.length > 0) {
			params.sort_column = state.sorted[0].id;
			params.sort_direction = state.sorted[0].desc ? 'desc' : 'asc';
		}
		if (keyword) {
			params.keyword = keyword;
		}
		this.setState({
			tableState: state,
		});
		this.props.userRolesFindAllByPageAndOptions(params);
	}

	onChangeKeywordHandler(e) {
		this.setState({
			keyword: e.target.value,
		}, this.onSubmitHandler);
	}

	onSubmitHandler(e) {
		e && e.preventDefault();
		const { tableState } = this.state;
		this.fetchData(tableState);
	}

	render() {
		const { userRolesByPage } = this.props;
		const { keyword } = this.state;
		const status = this.props.status.get('userRoles');
		const isLoading = status === 'fetching';
		return (
			<Fragment>
				<Row>
					<Colxx xxs="12">
						<div className="float-left">
							<BreadcrumbContainer
								heading={ <IntlMessages id="user-roles.heading" /> }
								items={ this.breadcrumb }
								match={ this.props.match }
							/>
						</div>
						<div className="float-right">
							<NavLink to="/app/user-role/create" className="btn btn-lg btn-primary">
								CREATE NEW
							</NavLink>
						</div>
						<div className="clearfix"></div>

						<form className="mb-3" onSubmit={ this.onSubmitHandler }>
							<div className="search-sm d-inline-block mr-1 mb-1 align-top">
								<input
									type="text"
									placeholder="Search"
									value={ keyword }
									onChange={ this.onChangeKeywordHandler }
								/>
							</div>
						</form>
					</Colxx>
				</Row>

				<Separator className="mb-5" />

				<Row>
					<Colxx xxs="12">
						<Card>
							<CardBody>
								<ReactTable
									manual
									data={ userRolesByPage.get('data') }
									pages={ userRolesByPage.get('max_page') }
									loading={ isLoading }
									onFetchData={ this.fetchData }
									columns={ this.columns }
									minRows={ 0 }
									showPageJump={ true }
									showPageSizeOptions={ true }
									PaginationComponent={ DataTablePagination }
								/>
							</CardBody>
						</Card>
					</Colxx>
				</Row>
			</Fragment>
		);
	}
}

export default connect(
	userRolesReducer.selector,
	{
		userRolesFindAllByPageAndOptions,
		errorReset,
	}
)(PageUserRoles);